module.exports = __webpack_public_path__ + "static/media/jugadores.b456c1d7.jpg";